import { SiJavascript } from 'react-icons/si'

export const JavascriptTech = () => {
    return (
        <div>
        <SiJavascript />
        <h4>Javascript</h4>
        </div>
    )
}